import { render, staticRenderFns } from "./PhotoelectricCurrentViz.vue?vue&type=template&id=3f5f126e&scoped=true"
import script from "./PhotoelectricCurrentViz.vue?vue&type=script&lang=js"
export * from "./PhotoelectricCurrentViz.vue?vue&type=script&lang=js"
import style0 from "./PhotoelectricCurrentViz.vue?vue&type=style&index=0&id=3f5f126e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5f126e",
  null
  
)

export default component.exports